import { RootState } from '../types'
import { ContentState } from './types'
import { ActionTree, ActionContext } from 'vuex'
import { adapter } from '../adapter'
import axios from 'axios'
import { AccountState } from '../account/types'

const youtubeKey = 'AIzaSyCwEdfzO6ASlv9v-ZMnGXCcYGAsPu-Jqe0'

const filterToString = (filters: { [key: string]: { [key: string]: boolean } }) => {
  let filterString = ''
  for (const key in filters) {
    filterString += key + '['
    for (const filterKey in filters[key]) {
      if (filters[key][filterKey] === true) {
        filterString += filterKey + ','
      }
    }
    filterString += ']'
  }
  return filterString
}

export const actions: ActionTree<ContentState, RootState> = {

  gradesTree (store: ActionContext<ContentState, RootState>): Promise<void> {
    return adapter.getRequest('/material/grades-tree/', {}).then((response) => {
      store.commit('SET_GRADES_TREE', response)
    })
  },
  loadBookTree (store: ActionContext<ContentState, RootState>, bookId: string): Promise<void> {
    return adapter.getRequest('/material/book-tree/', { id: bookId }).then((response) => {
      store.commit('SET_BOOK_TREE', response)
    })
  },
  youtubeDetails (store: ActionContext<ContentState, RootState>, youtubeId: string): Promise<{}> {
    return axios.get(`https://www.googleapis.com/youtube/v3/videos?id=${youtubeId}&part=contentDetails&key=${youtubeKey}`)
  },
  content (store: ActionContext<ContentState, RootState>, payload: { categoryId: string; bookId: string }): Promise<{}> {
    return adapter.getRequest('/material/content/', {
      categoryId: payload.categoryId,
      bookId: payload.bookId,
      searchTags: store.state.searchTags.reduce((acc, curr) => acc + curr + ',', ''),
      filters: filterToString(store.getters.filters)
    }, (store.rootState.account as AccountState).loggedIn, true) // Only sendtoken if loggedIn
  },
  contentById (store: ActionContext<ContentState, RootState>, contentId: string): Promise<{}> {
    return adapter.getRequest('/material/content-by-id/', { contentId }, false, true)
  },
  recommendedContent (store: ActionContext<ContentState, RootState>): Promise<{}> {
    return adapter.getRequest('/material/recommendations/', {}, true, true)
  },
  relatedContent (store: ActionContext<ContentState, RootState>, contentId: string): Promise<{}> {
    return adapter.getRequest('/material/related-content/', { contentId })
  },
  contentFormats (store: ActionContext<ContentState, RootState>): Promise<{}> {
    return adapter.getRequest('/material/content-format/')
  },
  contentTypes (store: ActionContext<ContentState, RootState>): Promise<{}> {
    return adapter.getRequest('/material/content-type/')
  },
  searchContent (store: ActionContext<ContentState, RootState>, searchText: string): Promise<{}> {
    return adapter.getRequest('/material/search-content/', { searchTags: searchText + ',', filters: filterToString(store.getters.filters) })
  },
  rate (store: ActionContext<ContentState, RootState>, payload: { contentId: string; rating: number }): Promise<{}> {
    return adapter.postRequest('/material/rating/', payload, true)
  },
  suggest (store: ActionContext<ContentState, RootState>, payload: {
    url: string;
    category: number;
    description: string;
    contentType: string;
    contentFormat: string;
  }): Promise<{}> {
    return adapter.postRequest('/material/suggestions/', payload, true)
  }
}
